import { Component, Input } from '@angular/core'
import * as lodash from 'lodash'

import { Channel, RateService, RateView, Rental } from '@tokeet/tv3-platform'

@Component({
  selector: 'app-rate-details-popover',
  templateUrl: './rate-details-popover.component.html',
  styleUrls: ['./rate-details-popover.component.scss'],
})
export class RateDetailsPopoverComponent {
  @Input() channels: Record<string, Channel>

  @Input() rental: Rental
  @Input() date: number

  @Input() rate: RateView
  @Input() rates: RateView[]

  @Input() module?: 'rates-calendar'

  constructor(public rateService: RateService) {}

  getCategoryName = (category: string, addWeekend = false) => {
    if (this.channels && this.channels[category]) {
      return this.channels[category].friendlyName
    }

    category = category === '00000000-0000-0000-0000-000000000000-tokeetwebsite' ? 'Tokeet Dashboard' : category

    let categoryName = lodash.startCase(category)

    if (addWeekend && categoryName === 'Base Rate' && this.isWeekend) {
      categoryName += ` (Weekend)`
    }

    return categoryName
  }

  getRates = (rate: RateView, rates: RateView[], channels: Record<string, Channel>, isChannelRates: boolean) => {
    const weekend = this.isWeekend

    if (!rate || !rates || !channels) return []

    channels['00000000-0000-0000-0000-000000000000-tokeetwebsite'] = Channel.deserialize({
      channelId: '00000000-0000-0000-0000-000000000000-tokeetwebsite',
      token: 'tokeet',
      friendlyName: 'Tokeet Dashboard',
      name: 'tokeet',
      type: 'auto',
    })

    rates = lodash.filter(rates, (r) => {
      return r && r.category !== rate.category && (isChannelRates ? !!channels[r.category] : !channels[r.category])
    })

    return lodash.sortBy(
      rates.map((r) => ({
        name: this.getCategoryName(r.category),
        price: weekend && r.weekend ? r.weekend : r.price,
      })),
      (item) => lodash.toLower(item.name)
    )
  }

  get isWeekend() {
    return this.rateService.isWeekend(this.date)
  }
}
